"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsPairMgr = void 0;
const RefWrapper_1 = require("./RefWrapper");
class SubsPairMgr {
    constructor(type, send) {
        this.subscribeTickerPair = new Map();
        this.type = type;
        this.send = send;
    }
    getKey(item) {
        return `${item.market}/${item.base}/${item.quote}/${item.interval || ""}`;
    }
    getSubData(subscribeTickerPair) {
        // 交易所列表
        const exchanges = [];
        const refWrappers = Array.from(subscribeTickerPair.values());
        refWrappers.forEach(({ value }) => {
            if (!value.base && !value.quote && !exchanges.includes(value.market)) {
                exchanges.push(value.market);
            }
        });
        // 交易对列表，如果对应的交易所已经按交易所订阅，这里就不需要单独订阅币对了
        const pairs = [];
        refWrappers.forEach(({ value }) => {
            if (exchanges.includes(value.market)) {
                return;
            }
            pairs.push({
                base: value.base,
                quote: value.quote,
                exchange: value.market,
                interval: value.interval,
            });
            if (!value.base && !value.quote && !exchanges.includes(value.market)) {
                exchanges.push(value.market);
            }
        });
        const data = [];
        if (exchanges.length > 0) {
            data.push(...exchanges.map((exchange) => ({ exchange })));
        }
        if (pairs.length > 0) {
            data.push(...pairs);
        }
        return data;
    }
    haveChanged(oldData, newData) {
        if (oldData.length !== newData.length) {
            return true;
        }
        return newData.some((item) => {
            // 有一个在老数据里不存在则认为有变化
            return !oldData.some((oldItem) => {
                return (oldItem.exchange === item.exchange &&
                    oldItem.base === item.base &&
                    oldItem.quote === item.quote &&
                    oldItem.interval === item.interval);
            });
        });
    }
    reSubscribe(data) {
        if (!this.type || !this.send) {
            return;
        }
        this.send(this.type, data);
    }
    addSubscribePair(param) {
        const oldData = this.getSubData(this.subscribeTickerPair);
        param.forEach((item) => {
            const key = this.getKey(item);
            const refValue = this.subscribeTickerPair.get(key);
            if (refValue) {
                refValue.add();
            }
            else {
                this.subscribeTickerPair.set(key, new RefWrapper_1.RefWrapper({
                    market: item.market,
                    base: item.base,
                    quote: item.quote,
                    interval: item.interval || "",
                }));
            }
        });
        const newData = this.getSubData(this.subscribeTickerPair);
        if (this.haveChanged(oldData, newData)) {
            this.reSubscribe(newData);
        }
    }
    removeSubscribePair(param) {
        const oldData = this.getSubData(this.subscribeTickerPair);
        const deleted = [];
        param.forEach((item) => {
            let refValue;
            const key = this.getKey(item);
            refValue = this.subscribeTickerPair.get(key);
            if (refValue) {
                refValue.delete();
                if (refValue.count <= 0) {
                    deleted.push(item);
                    this.subscribeTickerPair.delete(key);
                }
            }
        });
        const newData = this.getSubData(this.subscribeTickerPair);
        if (this.haveChanged(oldData, newData)) {
            this.reSubscribe(newData);
        }
        return deleted;
    }
    getSubscribePair() {
        return this.getSubData(this.subscribeTickerPair);
    }
}
exports.SubsPairMgr = SubsPairMgr;
